import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import '@animxyz/core';

const AuthLayout: React.FC = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return <>{children}</>;
};

export default AuthLayout;
